export const ADMIN = "ADMIN";
export const HR_DEPARTMENT = "HR DEPARTMENT";

export const HEAD_OFFICE = "HEAD OFFICE";
export const FACTORY_PLANT = "FACTORY PLANT";
export const LUNCH = "LUNCH";
export const DINNER = "DINNER";
export const BREAKFAST = "BREAK FAST";

export const CREATED_AS_TYPE = {
  absent: "ABSENT",
  weeklyOff: "WO",
  inTime: "IN_TIME",
  outTime: "OUT_TIME",
  halfTime: "HALF_TIME",
  fullTime: "FULL_TIME",
  earlyOut: "EARLY_OUT",
  overTime: "OVER_TIME",
  lateComing: "LATE_COMING",
  outDoorDuty: "OUTDOOR_DUTY",
  halfTime_3Late: "3_LATE_HALF_TIME",
  halfTime_2EO: "2_EARLY_OUT_HALF_TIME",
  oneHourLate: "1_HOUR_LATE",
  oneHourEarly: "1_HOUR_EARLY",
  privilegeLeave: "PRIVILEGE_LEAVE",
  needBasedLeave: "NEED_BASED_LEAVE",
  paternityLeave: "PATERNITY_LEAVE",
  maternityLeave: "MATERNITY_LEAVE",
  bereavementLeave: "BEREAVEMENT_LEAVE",
  compensatoryOff: "COMPENSATORY_OFF",
  optionalHoliday: "OPTIONAL_HOLIDAY",
  paidHoliday: "PAID_HOLIDAY",
  accidentalLeave: "ACCIDENTAL_LEAVE",
  WOP: "WOP"
};

// #817F09

const colors = {
  absentColor: "#F90716",
  accent: "#F3534A",
  black: "#323643",
  blue: "#586BF1",
  Cararra: "#fdfff5",
  customCmc: "#F3A036",
  customCmc2: "#1F1A17",
  danger: "#fa5c7c",
  dark: "#313a46",
  darkGreen: "#009387",
  elseColor: "#71797E",
  fullTimeColor: "#34BE82",
  gray: "#9DA3B4",
  gray2: "#C5CCD6",
  green: "#5cb85c",
  halfTimeColor: "#D9CE3F",
  info: "#39afd1",
  inTimeColor: "#85F4FF",
  leaveColor: "#C65200",
  light: "#e3eaef",
  lightBlue: "#2196F3",
  nullColor: "#D3D3D3",
  outDoorColor: "#5E454B",
  overTimeColor: "#7B113A",
  primary: "#cc5200",
  primary2: "#9B1FE8",
  secondary: "#ff6600",
  secondary2: "#6c757d",
  success: "#0acf97",
  tertiary: "#FFE358",
  undefinedColor: "#EEEEEE",
  warning: "#ffbc00",
  white: "#FFFFFF",
  wop: "#817F09"
};

export const CREATED_AS_COLOR = {
  [CREATED_AS_TYPE.absent]: "badge badge-danger",
  [CREATED_AS_TYPE.weeklyOff]: "badge badge-warning",
  [CREATED_AS_TYPE.WOP]: "badge badge-wop",
  [CREATED_AS_TYPE.inTime]: "badge badge-info",
  [CREATED_AS_TYPE.outTime]: "badge badge-info",
  [CREATED_AS_TYPE.halfTime]: "badge badge-warning",
  [CREATED_AS_TYPE.fullTime]: "badge badge-success",
  [CREATED_AS_TYPE.earlyOut]: "badge badge-warning",
  [CREATED_AS_TYPE.overTime]: "badge badge-primary",
  [CREATED_AS_TYPE.lateComing]: "badge badge-warning",
  [CREATED_AS_TYPE.outDoorDuty]: "badge badge-dark",
  [CREATED_AS_TYPE.halfTime_3Late]: "badge badge-warning",
  [CREATED_AS_TYPE.halfTime_2EO]: "badge badge-warning",
  [CREATED_AS_TYPE.oneHourLate]: "badge badge-warning",
  [CREATED_AS_TYPE.oneHourEarly]: "badge badge-warning",

  [CREATED_AS_TYPE.privilegeLeave]: "badge badge-leave",
  [CREATED_AS_TYPE.needBasedLeave]: "badge badge-leave",
  [CREATED_AS_TYPE.paternityLeave]: "badge badge-leave",
  [CREATED_AS_TYPE.maternityLeave]: "badge badge-leave",
  [CREATED_AS_TYPE.bereavementLeave]: "badge badge-leave",
  [CREATED_AS_TYPE.compensatoryOff]: "badge badge-leave",
  [CREATED_AS_TYPE.optionalHoliday]: "badge badge-leave",
  [CREATED_AS_TYPE.paidHoliday]: "badge badge-leave",
  [CREATED_AS_TYPE.accidentalLeave]: "badge badge-leave"
};

export const CREATED_AS_STATUS = {
  [null]: "-",

  [CREATED_AS_TYPE.absent]: "AB",
  [CREATED_AS_TYPE.weeklyOff]: "WO",
  [CREATED_AS_TYPE.WOP]: "WOP",
  [CREATED_AS_TYPE.inTime]: "IN",
  [CREATED_AS_TYPE.outTime]: "O",
  [CREATED_AS_TYPE.halfTime]: "HD",
  [CREATED_AS_TYPE.fullTime]: "FD",
  [CREATED_AS_TYPE.earlyOut]: "EO",
  [CREATED_AS_TYPE.overTime]: "OT",
  [CREATED_AS_TYPE.lateComing]: "LC",
  [CREATED_AS_TYPE.outDoorDuty]: "OD",
  [CREATED_AS_TYPE.halfTime_3Late]: "3HD",
  [CREATED_AS_TYPE.halfTime_2EO]: "3EO",
  [CREATED_AS_TYPE.oneHourLate]: "1HL",
  [CREATED_AS_TYPE.oneHourEarly]: "1HEO",

  [CREATED_AS_TYPE.privilegeLeave]: "PL",
  [CREATED_AS_TYPE.needBasedLeave]: "NBL",
  [CREATED_AS_TYPE.paternityLeave]: "PTL",
  [CREATED_AS_TYPE.maternityLeave]: "MTL",
  [CREATED_AS_TYPE.bereavementLeave]: "BL",
  [CREATED_AS_TYPE.compensatoryOff]: "CO",
  [CREATED_AS_TYPE.optionalHoliday]: "OH",
  [CREATED_AS_TYPE.paidHoliday]: "PH",
  [CREATED_AS_TYPE.accidentalLeave]: "AML"
};

export const ATTENDANCE_BACKGROUND_COLOR = {
  [CREATED_AS_TYPE.absent]: colors.absentColor,
  [CREATED_AS_TYPE.weeklyOff]: colors.gray2,

  [CREATED_AS_TYPE.inTime]: colors.lightBlue,
  [CREATED_AS_TYPE.outTime]: colors.info,
  [CREATED_AS_TYPE.halfTime]: colors.customCmc,
  [CREATED_AS_TYPE.fullTime]: colors.success,
  [CREATED_AS_TYPE.earlyOut]: colors.tertiary,
  [CREATED_AS_TYPE.overTime]: colors.primary2,
  [CREATED_AS_TYPE.lateComing]: colors.danger,
  [CREATED_AS_TYPE.outDoorDuty]: colors.dark,
  [CREATED_AS_TYPE.halfTime_3Late]: colors.customCmc,
  [CREATED_AS_TYPE.oneHourLate]: colors.customCmc,
  [CREATED_AS_TYPE.oneHourEarly]: colors.customCmc,

  [CREATED_AS_TYPE.privilegeLeave]: colors.leaveColor,
  [CREATED_AS_TYPE.needBasedLeave]: colors.leaveColor,
  [CREATED_AS_TYPE.paternityLeave]: colors.leaveColor,
  [CREATED_AS_TYPE.maternityLeave]: colors.leaveColor,
  [CREATED_AS_TYPE.bereavementLeave]: colors.leaveColor,
  [CREATED_AS_TYPE.compensatoryOff]: colors.leaveColor,
  [CREATED_AS_TYPE.optionalHoliday]: colors.leaveColor,
  [CREATED_AS_TYPE.paidHoliday]: colors.leaveColor
};

export const SHIFT_TYPE = {
  headOffice: "HOBGS",
  headOfficeNineThirty: "HOBGS_0930",
  headOfficeTenThirty: "HOBGS_1030",
  headOfficeEleven: "HOBGS_1100",
  bhiwandi: "BOGS",
  bhiwandiNineThirty: "BOGS_0930",
  worli: "WOGS",
  worliNineThirty: "WOGS_0930",
  unitOneGeneral: "U1SGS",
  unitOneFirst: "U1SFS",
  unitOneNight: "U1SNS",
  unitOneFirstEight: "U1SFS_0818",
  unitOneGeneralTen: "U1SGS_1000",
  unitOneNightSeven: "U1SNS_1900",
  unitOneNightSevenToSeven: "U1SNS_1907",
  unitOneNightNine: "U1SNS_2100",
  unitOneNightTen: "U1SNS_2200",
  unitThreeGeneral: "U3SGS",
  unitThreeFirst: "U3SFS",
  unitThreeNight: "U3SNS",
  unitFourGeneral: "U4SGS",
  unitFourFirst: "U4SFS",
  unitFourNight: "U4SNS",
  weeklyOff: "WO"
};

export const SHIFT_TYPE_OBJ = {
  [SHIFT_TYPE.headOffice]: "HOBGS",
  [SHIFT_TYPE.headOfficeNineThirty]: "HOBGS_0930",
  [SHIFT_TYPE.headOfficeTenThirty]: "HOBGS_1030",
  [SHIFT_TYPE.headOfficeEleven]: "HOBGS_1100",
  [SHIFT_TYPE.bhiwandi]: "BOGS",
  [SHIFT_TYPE.bhiwandiNineThirty]: "BOGS_0930",
  [SHIFT_TYPE.worli]: "WOGS",
  [SHIFT_TYPE.worliNineThirty]: "WOGS_0930",
  [SHIFT_TYPE.unitOneGeneral]: "U1SGS",
  [SHIFT_TYPE.unitOneFirst]: "U1SFS",
  [SHIFT_TYPE.unitOneNight]: "U1SNS",
  [SHIFT_TYPE.unitOneFirstEight]: "U1SFS_0818",
  [SHIFT_TYPE.unitOneGeneralTen]: "U1SGS_1000",
  [SHIFT_TYPE.unitOneNightSeven]: "U1SNS_1900",
  [SHIFT_TYPE.unitOneNightSevenToSeven]: "U1SNS_1907",
  [SHIFT_TYPE.unitOneNightNine]: "U1SNS_2100",
  [SHIFT_TYPE.unitOneNightTen]: "U1SNS_2200",
  [SHIFT_TYPE.unitThreeGeneral]: "U3SGS",
  [SHIFT_TYPE.unitThreeFirst]: "U3SFS",
  [SHIFT_TYPE.unitThreeNight]: "U3SNS",
  [SHIFT_TYPE.unitFourGeneral]: "U4SGS",
  [SHIFT_TYPE.unitFourFirst]: "U4SFS",
  [SHIFT_TYPE.unitFourNight]: "U4SNS",
  [SHIFT_TYPE.weeklyOff]: "WO"
};

export const SHIFT_COLOR = {
  [SHIFT_TYPE.headOffice]: "badge badge-success",
  [SHIFT_TYPE.headOfficeNineThirty]: "badge badge-info",
  [SHIFT_TYPE.headOfficeTenThirty]: "badge badge-dark",
  [SHIFT_TYPE.headOfficeEleven]: "badge badge-danger",
  [SHIFT_TYPE.bhiwandi]: "badge badge-success",
  [SHIFT_TYPE.bhiwandiNineThirty]: "badge badge-dark",
  [SHIFT_TYPE.worli]: "badge badge-success",
  [SHIFT_TYPE.worliNineThirty]: "badge badge-dark",
  [SHIFT_TYPE.unitOneGeneral]: "badge badge-success",
  [SHIFT_TYPE.unitOneFirst]: "badge badge-info",
  [SHIFT_TYPE.unitOneNight]: "badge badge-dark",
  [SHIFT_TYPE.unitThreeGeneral]: "badge badge-success",
  [SHIFT_TYPE.unitThreeFirst]: "badge badge-info",
  [SHIFT_TYPE.unitThreeNight]: "badge badge-dark",
  [SHIFT_TYPE.unitFourGeneral]: "badge badge-success",
  [SHIFT_TYPE.unitFourFirst]: "badge badge-info",
  [SHIFT_TYPE.unitFourNight]: "badge badge-dark",
  [SHIFT_TYPE.weeklyOff]: "badge badge-warning",
  [SHIFT_TYPE.unitOneFirstEight]: "badge badge-dark",
  [SHIFT_TYPE.unitOneGeneralTen]: "badge badge-success",
  [SHIFT_TYPE.unitOneNightSeven]: "badge badge-info",
  [SHIFT_TYPE.unitOneNightSevenToSeven]: "badge badge-dark",
  [SHIFT_TYPE.unitOneNightNine]: "badge badge-danger",
  [SHIFT_TYPE.unitOneNightTen]: "badge badge-info"
};
